import * as React from 'react';

import { Grid, LoadingSection, PageGridContainer, Typography2 } from '@coursera/cds-core';

import Section from 'bundles/unified-description-page-common/components/shared/Section';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

const EnterpriseSkillPathwayV2Loading = () => {
  return (
    <Section>
      <PageGridContainer>
        <Grid container spacing={32}>
          <Grid item xs={12}>
            <Typography2 variant="titleSmall" component="h2">
              {_t('Skill goals')}
            </Typography2>
          </Grid>
          <Grid item xs={12}>
            <LoadingSection label={_t('Loading...')} />
          </Grid>
        </Grid>
      </PageGridContainer>
    </Section>
  );
};

export default EnterpriseSkillPathwayV2Loading;
